import { render, staticRenderFns } from "./assessmentPageComponent.vue?vue&type=template&id=5b04d9d1&scoped=true&"
import script from "./assessmentPageComponent.vue?vue&type=script&lang=ts&"
export * from "./assessmentPageComponent.vue?vue&type=script&lang=ts&"
import style0 from "./assessmentPageComponent.vue?vue&type=style&index=0&id=5b04d9d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b04d9d1",
  null
  
)

export default component.exports